import { ROUTES } from "../../../../module/constants";
import { generalConst } from "../../../../module/globalInterface";

export const USERS_MGMT_CONSOLE_ADMIN_URLS: generalConst = {
  BASE_URL: ROUTES.ADMIN_USERS_MGMT,
  SECTION_CONFIG: `${ROUTES.ADMIN_USERS_MGMT}/configurations`,
  STEP_ONE: `${ROUTES.ADMIN_USERS_MGMT}/stepOne`,
  STEP_TWO: `${ROUTES.ADMIN_USERS_MGMT}/stepTwo`,
  STEP_THREE: `${ROUTES.ADMIN_USERS_MGMT}/stepThree`,
  STEP_FOUR: `${ROUTES.ADMIN_USERS_MGMT}/stepFour`,
};

export const ABILITATION_MANAGEMENT_FORM_FILTER =
  "AbilitationManagementFormFilter";
export interface IAbilitationManagementProps {
  resetState: () => {};
}

export interface IBooleanModal {
  accountId: string | null;
  identitySystemId: number;
  result: boolean;
}

export interface IAccountOpModel {
  accountId: string;
  password?: string;
  identitySystemId: string;
  userCode: string;
}

export enum UserManagementConfigButtonCode {
  USRENT = 1,
  MOBILE = 2,
  RSTPWD = 3,
  CHGPWD = 4,
  BLKACC = 5,
  UNKACC = 6,
}

export interface UserManagementConfigButton {
  role: string;
  operationCode: UserManagementConfigButtonCode;
  operationName: string;
  isEnabled: boolean;
}

export const STATE_IDENTIFIER = {
  SELECTED_OFFICE: "SelectedOffice",
  SELECTED_OU: "SelectedOu",
  IS_SELF_SELECTED: "IsSelfSelected",
  SELECTED_USER: "SelectedUserManagement",
  ADDED_ENTITLEMENTS: "AddedEntitlements",
  ADDED_BR: "AddedBR",
  DELETED_ENTITLEMENTS: "DeletedEntitlements",
  DELETED_BR: "DeletedBR",
  MODIFIED_ENTITLEMENTS: "ModifiedEntitlements",
  MODIFIED_BR: "ModifiedBR",
  STEP_ONE: "StepOne",
  OFFICES: "Offices",
  STEP_TWO: "StepTwo",
  USER: "User",
  STEP_THREE_USERS_MANAGEMENT: "stepThreeUsersManagement",
  PREV_ENTITLEMENTS: "PrevEntitlements",
  ENTITLEMENTS: "Entitlements",
  BUSINESS_ROLES: "BusinessRoles",
  TOTAL_ENTITLEMENTS: "TotalEntitlements",
  STEP_FOUR: "StepFour",
  DELEGATOR: "Delegator",
  COMMENT: "Comment",
  CALL_STATE: "CallState",
  ENTITLEMENTS_BR_SELECTED: "EntitlementsBRSelected",
  EXISTING_SAME_DB: "ExistingSameDB",
  ATTACHMENTS: "Attachments",
  PROPAGATIONS: "Propagations",
  SELECTED_USERS: "SelectedUsers",
  EXCEPTION_CREATION: "ExceptionCreation",
  ALL_USERS: "UserAccounts",
  LOADER_IDENTIFIER: "LoaderIdentifier",
  RESPONSE_STATE: "ResponseState",
  ERROR_MESSAGE: "errorMessage",
  ABILITATION_DATE: "abilitationDate",
  SOD_CONFLICTS: "sodConflicts",
  IS_COMMENT_COMPULSORY: "isCommentCompulsory",
  PASSWORD_POLICY: "passwordPolicy",
  PAGINATED_ENTITLEMENTS: "paginatedEntitlementsRawData",
  PAGINATED_BUSINESS_ROLES: "paginatedBusinessRoleRawData",
  ROLES: "roles",
  CONFIG_BUTTONS: "configButtons",
  CONFIGS: "configs",
};

export enum changePwdErrorMessages {
  NOT_ALLOWED = "Account not allowed to change password",
  NOT_VALID = "Password not valid",
  NOT_POSSIBLE = "Change password not possible",
}

export const LIST_IDENTIFIER: string = "list";
export const LOADER_IDENTIFIER: string = "loader";
export const BUSINESS_ROLES_IDENTIFIER: string = "businessRoles";
export const ENTITLEMENTS_IDENTIFIER: string = "entitlements";
export const SHOW_TABLE_IDENTIFIER: string = "showTable";
